<template>
  <v-tooltip location="top" activator="parent">
    <slot />
  </v-tooltip>
</template>